// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card-icons{display:flex;margin:0 -1px}@media only screen and (min-width:992px){.product-card-icons{margin:0 -4px}}.product-card-icons--sm .product-card-icons__image,.product-card-icons__image{width:16px;height:16px;margin:0 1px}@media only screen and (min-width:992px){.product-card-icons__image{position:relative;z-index:3;width:24px;height:24px;margin:0 4px}.product-card-icons__image:hover .product-card-icons__tooltip{display:block}}", ""]);
// Exports
module.exports = exports;
